<template>
    <div>
        <div class="citation-container" v-if="citations && citations.length > 0" style="border-bottom: 1px solid #aaa;">
            <div style="border: 1px solid #aaa; padding: 8px; font-weight: bold; margin-top: 20px;">
                    References:
            </div>
            <div
            v-if="citations"
            v-for="(citationEntry, citationIndex) in citations" 
            :key="citationIndex"
            style="border-left: 1px solid #aaa; border-right: 1px solid #aaa;">
                <div 
                v-html="processCitation(citationEntry)" 
                style="border-bottom: 1px dotted #aaa; padding: 8px; font-size: 85%;">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            citations: {
                type: Array
            }
        },
        methods: {
            processCitation: function(citationText){
                var urlRegex = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+~#?&//=]*)/
                return citationText.replace(urlRegex, (v) => {
                    v = v.replace(/https?:\/\//, "")
                    return "<a href='//"+v+"' target='_blank'>"+v+"</a>"
                })
            }
        }
    }
</script>